import { _retrieveData } from "../../../utils/local-storage";
import axios from "axios";

const test_url="http://127.0.0.1:8000/api/v0";
const live_url=process.env.REACT_APP_API_URL;
async function getCourseListAPI() {
  try {
    const { data } = await axios.get(
      live_url + `/course/list`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data_r: data.data,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      message:err?.message,
      isLoading: false,
      isError: true,
    };
  }
}

async function getCourseItemAPI(uuid) {
  try {
    const { data} = await axios.get(
      live_url + `/course/view/${uuid}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data_r: data.data,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      message:err?.message,
      isLoading: false,
      isError: true,
    };
  }
}

const getRequest = async (url) => {
  try {
    const { data,message } = await axios.get(
      live_url + `${url}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data_r: data.data,
      message:message,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      message:err?.message,
      isLoading: false,
      isError: true,
    };
  }
}

const authGetRequest = async (url) => {
  try {
    const token = await _retrieveData("user_token");
    const { data,message } = await axios.get(
      live_url + `${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data_r: data.data,
      message:message,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      message:err?.message,
      isLoading: false,
      isError: true,
    };
  }
}

const authPostRequest = async (url, input) => {
  try {
    const token = await _retrieveData("user_token");
    const { data } = await axios.post(
      live_url + `${url}`,
      input,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          'content-type': 'multipart/form-data'
        },
      }
    );
    return {
      data_r: data.data,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      isLoading: false,
      isError: true,
    };
  }
};


const authGetPaginate = async (url) => {
  try {
    const token = await _retrieveData("user_token");
    const { data,message } = await axios.get(
       `${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data_r: data.data,
      message:message,
      isLoading: !data,
      isError: false,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      data_r: err,
      message:err?.message,
      isLoading: false,
      isError: true,
    };
  }
}

export {
  getCourseListAPI,
  getCourseItemAPI,
  authPostRequest,
  authGetRequest,
  getRequest,
  authGetPaginate
};
